export const theme = {
  colors: {
    slate: {
      10: "#bfcbd6",
      50: "#688198",
      100: "#627a91",
      200: "#5d7489",
      300: "#596e82",
      400: "#54687b",
      500: "#4f6274",
      600: "#4a5c6c",
      700: "#455665",
      800: "#333e4a",
      900: "#1f262d",
    },
    rust: {
      10: "#ffe3dc",
      50: "#C8694E",
      100: "#be573a",
      200: "#b95539",
      300: "#b45237",
      400: "#af5036",
      500: "#aa4e34",
      600: "#a54b33",
      700: "#a04931",
      800: "#9b4730",
      900: "#96452e",
    },
    delicate: {
      10: "#f7f9fb",
      50: "#e4edf2",
      100: "#d4e3ea",
      200: "#c5d9e3",
      300: "#b6cfdc",
      400: "#a7c5d5",
      500: "#98bbcd",
      600: "#89b1c6",
      700: "#7aa7bf",
      800: "#6b9db8",
      900: "#5c93b0",
    },
    sand: {
      10: "#fff8e6",
      50: "#d8be86",
      100: "#d6bb82",
      200: "#d5b97d",
      300: "#d4b779",
      400: "#d2b575",
      500: "#d1b371",
      600: "#d0b16d",
      700: "#ceae69",
      800: "#cdac65",
      900: "#cba961",
    },
    herb: {
      10: "#f0fff4",
      50: "#d8ffd5",
      100: "#bdecb9",
      200: "#b1e7ac",
      300: "#abe3a7",
      400: "#9edb9a",
      500: "#94d08f",
      600: "#87c282",
      700: "#82be7c",
      800: "#7cbb76",
      900: "#74b76e",
    },
  },
};
